// extracted by mini-css-extract-plugin
export default {"TermsPage":"IyLObHU-SIZC9xcia1Y5ww=="};